<template>
  <a-form-model ref="form" :model="form" :rules="rules">
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-model-item label="Date Guarantee" prop="date">
          <a-date-picker placeholder="Select Date" v-model="form.date" format="DD-MM-YYYY" allowClear />
        </a-form-model-item>
        <a-form-model-item label="Type" prop="type">
          <a-radio-group buttonStyle="solid" v-model="form.type" @change="changeType" :disabled="disabledType">
            <a-radio-button value="1">As Winner</a-radio-button>
            <a-radio-button value="0">As Companion</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Guarantee Period" prop="duedate">
          <!-- <a-date-picker
              placeholder="Select Date"
              v-model="form.duedate"
              format="DD-MM-YYYY"
              allowClear
            /> -->
          <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="form.duedate" :format="getDefaultDateFormat"
            allowClear />
        </a-form-model-item>
        <a-form-model-item label="Project Name" prop="projectname">
          <a-input v-model="form.projectname" />
        </a-form-model-item>
        <a-form-model-item label="Account Manager" prop="user_am">
          <a-select showSearch v-model="form.user_am" optionFilterProp="children" :filterOption="filterOption">
            <a-select-option v-for="item in getAccountMngr" :key="item.tlc" :value="item.tlc">
              {{ item.nama }} ( {{ item.tlc }} )</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Nominal" prop="nominal" v-if="form.type == '0'">
          <a-input-number class="m-width-full" v-model="form.nominal" @keydown="onlyNumber"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"></a-input-number>
        </a-form-model-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-model-item label="Obligee Name" prop="nameobligee">
          <a-input v-model="form.nameobligee" />
        </a-form-model-item>
        <a-form-model-item label="Obligee Address" prop="addressobligee">
          <a-input v-model="form.addressobligee" />
        </a-form-model-item>
        <a-form-model-item label="Category" prop="categori">
          <a-select showSearch v-model="form.categori" optionFilterProp="children" :filterOption="filterOption">
            <a-select-option v-for="item in categoryList" :key="item.key" :value="item.key">
              {{ item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="lblprjectrcv" prop="projectreceive" v-if="form.type == '0'">
          <a-input v-model="form.projectreceive" />
        </a-form-model-item>
        <a-form-model-item label="Contact Person" prop="contractperson" v-if="form.type == '0'">
          <a-input v-model="form.contractperson" />
        </a-form-model-item>
        <a-form-model-item label="Bank Account" prop="funding" v-if="form.type == '0'">
          <a-select showSearch v-model="form.funding" optionFilterProp="children" :filterOption="filterOption">
            <a-select-option v-for="item in bank" :key="item.value"
              :value="item.nama_bank + ' ( ' + item.kode_rekening + ' )'">
              {{ item.text }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Bank Site" prop="location">
          <!-- <a-input v-model="form.location" /> -->
          <a-radio-group buttonStyle="solid" v-model="form.location">
            <a-radio-button value="Surabaya">Surabaya</a-radio-button>
            <a-radio-button value="Jakarta">Jakarta</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item ref="file" prop="file" label="File Attachment">
          <a-upload v-model="form.file" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
            :remove="handleRemoveList">
            <a-button ref="btndocument" icon="upload">Select File
            </a-button>
          </a-upload>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
  <!--div class="action">
      <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
    </div-->
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "InformationBidBondRequest",
  props: ["id", "dataProcessed"],
  mixins: [GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (!this.isEdit && (this.push == null || this.push.length == 0)) {
        callback(new Error("Please input File Attachment"));
      } else {
        callback();
      }
    };
    return {
      mode: "Create",
      disabledType: false,
      loading: {
        submit: false,
      },
      form: {
        date: null,
        guaranteeNo: null,
        location: 'Surabaya',
        duedate: null,
        nominal: null,
        file: null,
        projectname: null,
        projectreceive: null,
        contractperson: null,
        funding: null,
        type: null,
        user_am: null,
        nameobligee: null,
        addressobligee: null,
        categori: null,
      },
      dataedit: {},
      rules: {
        date: {
          required: true,
          message: "Please input Date",
          trigger: "change",
        },
        guaranteeNo: {
          required: true,
          message: "Please input Guarantee No",
          trigger: "blur",
        },
        location: {
          required: true,
          message: "Please input Location",
          trigger: "blur",
        },
        duedate: {
          required: true,
          message: "Please input Due Date",
          trigger: "change",
        },
        nominal: {
          required: true,
          message: "Please input Nominal",
          trigger: "blur",
        },
        file: [{
          required: true,
          validator: doc_validation,
          trigger: "change"
        },
        ],
        projectname: {
          required: true,
          message: "Please input Project Name",
          trigger: "blur",
        },
        projectreceive: {
          required: true,
          message: "Please input Project Owner",
          trigger: "blur",
        },
        contractperson: {
          required: true,
          message: "Please input Contract Person",
          trigger: "blur",
        },
        funding: {
          required: true,
          message: "Please input Bank Account",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "Please input Type",
          trigger: "blur",
        },
        user_am: {
          required: true,
          message: "Please input Account Manager",
          trigger: "blur",
        },
        nameobligee: {
          required: true,
          message: "Please input obligee Name",
          trigger: "change",
        },
        addressobligee: {
          required: true,
          message: "Please input obligee Address",
          trigger: "change",
        },
        categori: {
          required: true,
          message: "Please input Category",
          trigger: "blur",
        },
      },
      bank: [],
      currency: [],
      push: [],
      category_list: [{
        key: "Penawaran", label: "Jaminan Penawaran"
      }, {
        key: "Pelaksanaan", label: "Jaminan Pelaksanaan"
      }, {
        key: "Uang muka", label: "Jaminan Uang Muka"
      }, {
        key: "Pemeliharaan", label: "Jaminan Pemeliharaan"
      }]
    };
  },
  computed: {
    ...mapGetters(["getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getAccountMngr"]),
    lblprjectrcv() {
      return this.form.type == '1' ? 'Companion Name' : 'Project Owner'
    },
    categoryList() {
      // return this.form.type == "1" ? _.filter(this.category_list, (e) => e.key != "Penawaran") : _.filter(this.category_list, (e) => e.key == "Penawaran")
      return this.category_list
    }
  },
  watch: {
    // dataProcessed() {
    //   this.initialData();
    // },
  },
  created() {
    this.$store.dispatch("FETCH_ACCOUNT_MANAGER");
    this.fetch();
    this.initialData();
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleSaveProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSaveProcess);
  },
  methods: {
    moment,
    initialData() {
      if (this.dataProcessed.information.form) {
        this.form.categori = this.dataProcessed.information.form.categori;
        this.form.contractperson = this.dataProcessed.information.form.contractperson;
        this.form.date = moment(this.dataProcessed.information.form.date, 'YYYY-MM-DD');
        this.form.duedate = [moment(this.dataProcessed.information.form.duedate[0], 'YYYY-MM-DD'),
        moment(this.dataProcessed.information.form.duedate[1], 'YYYY-MM-DD')];
        this.form.funding = this.dataProcessed.information.form.funding;
        this.form.addressobligee = this.dataProcessed.information.form.addressobligee;
        this.form.nameobligee = this.dataProcessed.information.form.nameobligee;
        this.form.projectname = this.dataProcessed.information.form.projectname;
        this.form.projectreceive = this.dataProcessed.information.form.projectreceive;
        this.form.type = this.dataProcessed.information.form.type;
        this.form.user_am = this.dataProcessed.information.form.user_am;
        this.push = [this.dataProcessed.information.attachment[0]];

        if (this.dataProcessed.information.form.type == "0") {
          this.form.nominal = this.dataProcessed.information.form.nominal;
        }
      } else {
        this.form = {
          date: moment(),
          guaranteeNo: null,
          location: 'Surabaya',
          duedate: null,
          nominal: null,
          file: null,
          projectname: null,
          projectreceive: null,
          contractperson: null,
          funding: null,
          type: "1",
          user_am: null,
          addressobligee: null,
          nameobligee: null,
          categori: null
        };
      }
    },
    fetch() {
      this.$store
        .dispatch("getListBankBidBondRequest", { auth: this.getAuth })
        .then((res) => {
          this.bank = res;
        });

      if (this.id) {
        this.form = this.dataProcessed.information.form;
      }
      // if (this.id) {
      //     this.$store
      //       .dispatch("getRevbidbondReq", { auth: this.getAuth, payload: this.id })
      //       .then((res) => {
      //         this.dataedit = res.hdr[0];
      //         this.mode = "Edit";
      //         this.disabledType=true;

      //         let typefile = this.dataedit.file_nm.substr(this.dataedit.file_nm.lastIndexOf("."));

      //         if (typefile == ".xls"){
      //           typefile = "data:application/vnd.ms-excel;base64,";
      //         } else if(typefile == ".xlsx"){
      //           typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      //         } else if(typefile == ".doc"){
      //           typefile = "data:application/msword;base64,";
      //         } else if(typefile == ".docx"){
      //           typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      //         } else if(typefile == ".pdf"){
      //           typefile = "data:application/pdf;base64,";
      //         } else if(typefile == ".jpeg" || typefile == ".jpg"){
      //           typefile = "data:image/jpeg;base64,";
      //         } else if(typefile == ".png"){
      //           typefile = "data:image/png;base64,";
      //         }

      //         var file = this.dataURLtoFile(
      //           typefile + this.dataedit.files,
      //           this.dataedit.file_nm
      //         );
      //         file.uid = "vc-upload-1-1";
      //         file.status = "done";
      //         file.exist = true;
      //         file.url = this.$serviceUrl + this.dataedit.file_url;
      //         this.push.push(file);
      //       });

      // }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleSave() {
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else if (this.mode === "Create") {
        this.confirmMessage("confirm-save");
      }
    },
    handleSaveProcess() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.submit = true;
        let data = new FormData();
        data.append("tlc", this.getAuth.username);
        data.append("date_guarantee", moment(this.form.date).format(this.getDateTimeStandartFormat));
        data.append("location", this.form.location);
        data.append("receiver_project", this.form.projectreceive);
        data.append("contact_person", this.form.contractperson);
        data.append("project_name", this.form.projectname);
        data.append("funding", this.form.funding ? this.form.funding : "-");
        data.append("nominal", this.form.nominal);
        data.append("start_due_date", moment(this.form.duedate[0]).format(this.getDateTimeStandartFormat));
        data.append("end_due_date", moment(this.form.duedate[1]).format(this.getDateTimeStandartFormat));
        data.append("type", this.form.type);
        if (this.form.user_am != null) {
          data.append("user_am", this.form.user_am);
        }
        data.append("upload_file", this.push[0]);
        if (this.mode == "Edit") {
          data.append("bidbond_request_id", this.id);
        }

        this.$store
          .dispatch(this.mode == "Edit" ? "postRevbidbondReq" : "submitBidBondRequest", { auth: this.getAuth, payload: data })
          .then((res) => {
            if (this.mode == "edit") {
              this.displayMessage("success-edit");
            } else {
              this.displayMessage("success");
            }
            this.loading.submit = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            this.displayMessageValue("basic-error", err.response.data.message);
            this.loading.submit = false;
          });
      });
    },
    handleRemoveList() {
      this.form.file = undefined;
      this.push = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    changeType(val) {
      Event.$emit("setstepRulesDtl", val.target.value == "1" ? true : false);
      this.form.categori = null;
      if (val.target.value == "1") {
        this.form.nominal = null;
        this.form.contractperson = null;
        this.form.projectreceive = null;
        this.form.funding = null;
      }
    },
    handleRef() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.id) {
          this.form.note = this.dataProcessed.information.form.note;
        }

        let data = {
          form: this.form,
          attachment: this.push
        }
        Event.$emit("emitBidbondReq", data);
      });
    }
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
